import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "font-semibold text-gray-lp-300 text-16px text-left",
  "data-testid": "handover-eligibility-failed-modal-title"
}
const _hoisted_2 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_component_ModalV2, {
    width: "w-1000px",
    onClose: _ctx.close,
    isCustomTitle: true,
    title: _ctx.title,
    titlePadding: "px-4 py-4",
    contentPadding: "px-4 pb-4",
    footerPadding: "px-4 py-4",
    footerBgColor: "bg-white",
    isShadows: false,
    closeButtonTestId: "handover-eligibility-failed-modal-close-x",
    "data-testid": "handover-eligibility-failed-modal",
    isRoundedLg: "",
    showBorderTitle: false
  }, {
    "custom-title": _withCtx(() => [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    content: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_TableV2, {
          columns: _ctx.columns,
          data: _ctx.failedSttList,
          loading: _ctx.isLoading,
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
          isHardPagination: false,
          hidePagination: true,
          borderBottom: false,
          isDetailAble: false,
          isNoPaddingBottom: "",
          "data-testid": "handover-eligibility-failed-table",
          bgHeader: "bg-white",
          isSpaceTop: false
        }, null, 8, ["columns", "data", "loading", "pagination"])
      ])
    ]),
    _: 1
  }, 8, ["onClose", "title"]))
}